<div class="product-selection" [formGroup]="productForm">
  <div class="split-form-body">
    <div class="form-group flex-basis-50">
      <label i18n
        >Compagnie d'assurance <span class="text-danger">*</span></label
      >
      <select
        name="categoryId"
        class="form-control form-select"
        formControlName="categoryId"
        [ngClass]="{
          'is-invalid':
            formControls['categoryId'].touched &&
            formControls['categoryId'].errors,
        }"
      >
        <option [ngValue]="" i18n>Aucune compagnie</option>
        <option
          *ngFor="let category of categoryData"
          [ngValue]="category.categoryId"
          [attr.data-catname]="category.categoryName"
          [attr.data-catfrenchname]="category.categoryNameInFrench"
          [attr.data-catlogo]="category.logo"
        >
          <ng-container *ngIf="lngCode === 'en'">{{
            category.categoryName
          }}</ng-container>
          <ng-container *ngIf="lngCode === 'fr'">{{
            category.categoryNameInFrench
          }}</ng-container>
        </option>
      </select>
      <div
        *ngIf="
          formControls['categoryId'].touched &&
          formControls['categoryId'].invalid
        "
        class="invalid-feedback"
      >
        <div
          *ngIf="
            formControls['categoryId'].errors &&
            formControls['categoryId'].errors['required']
          "
          i18n
        >
          La compagnie d'assurance est requise.
        </div>
      </div>
    </div>
    <div class="form-group flex-basis-50">
      <label i18n>Produit d'assurance <span class="text-danger">*</span></label>
      <select
        name="subCategoryId"
        class="form-control form-select"
        formControlName="subCategoryId"
        [ngClass]="{
          'is-invalid':
            formControls['subCategoryId'].touched &&
            formControls['subCategoryId'].errors,
        }"
      >
        <option value="" i18n>Not Selected</option>
        <option
          *ngFor="let category of subCategoryData"
          [ngValue]="category.subCategoryId"
          [attr.data-subcatname]="category.subCategoryName"
          [attr.data-subcatfrenchname]="category.subCategoryNameInFrench"
        >
          <ng-container *ngIf="lngCode === 'en'">{{
            category.subCategoryName
          }}</ng-container>
          <ng-container *ngIf="lngCode === 'fr'">{{
            category.subCategoryNameInFrench
          }}</ng-container>
        </option>
      </select>
      <div
        *ngIf="
          formControls['subCategoryId'].touched &&
          formControls['subCategoryId'].invalid
        "
        class="invalid-feedback"
      >
        <div
          *ngIf="
            formControls['subCategoryId'].errors &&
            formControls['subCategoryId'].errors['required']
          "
          i18n
        >
          Le produit est requis.
        </div>
      </div>
    </div>
  </div>

  <div
    class="split-form-body product-selection-body"
    *ngIf="productTreeData?.length > 0"
  >
    <div class="form-group flex-basis-50">
      <label i18n>Couvertures <span class="text-danger">*</span></label>
      <div class="mb-3">
        <div class="lty-input-icon-group search-bar">
          <input
            class="form-control lty-form-control"
            placeholder="Rechercher"
            i18n-placeholder="Rechercher"
            [formControl]="searchFormControl"
            placeholder="Rechercher"
            i18n-placeholder="@@searchProduct"
          />

          <div class="input-icon">
            <app-search-icon
              height="20px"
              width="20px"
              color="var(--gray-500)"
            />
          </div>
        </div>
      </div>
      <div
        [ngClass]="{
          'is-invalid':
            formControls['product'].touched && formControls['product'].errors,
        }"
      >
        <app-tree
          [data]="filteredProductTreeData"
          [selectable]="true"
          [collapsable]="false"
          [initialSelection]="selectedProductIdsAsArray()"
          (selectionChanged)="onProductSelectionChanged($event)"
          *ngIf="filteredProductTreeData && filteredProductTreeData.length > 0"
        />
        <div
          *ngIf="
            !filteredProductTreeData || filteredProductTreeData.length === 0
          "
          class="text-muted"
        >
          <span
            *ngIf="
              searchFormControl.value && searchFormControl.value.trim() !== ''
            "
            i18n
          >
            Aucune couverture trouvée
          </span>
          <span
            *ngIf="
              !searchFormControl.value || searchFormControl.value.trim() === ''
            "
            i18n
          >
            Aucune couverture disponible
          </span>
        </div>
      </div>
      <div
        *ngIf="
          formControls['product'].touched && formControls['product'].invalid
        "
        class="invalid-feedback"
      >
        <div
          *ngIf="
            formControls['product'].errors &&
            formControls['product'].errors['required']
          "
          i18n
        >
          Product is required.
        </div>
      </div>
    </div>

    <div
      class="form-group flex-basis-50"
      *ngIf="productList && productList.length > 0"
    >
      <label i18n>Couvertures sélectionnées</label>
      <ng-container formArrayName="productList">
        <ng-container
          *ngFor="let product of displayableProductControls; let i = index"
        >
          <div class="layout-card mb-16" [formGroup]="product">
            <div class="product-card-title">
              <ng-container i18n>Couverture </ng-container>{{ i + 1 }}
            </div>
            <div class="d-flex justify-content-between">
              <div class="flex-basis-70">
                <input
                  type="text"
                  class="form-control"
                  readonly
                  formControlName="displayProductName"
                  [ngClass]="{
                    'is-invalid':
                      product.get('displayProductName')?.touched &&
                      product.get('displayProductName')?.errors,
                  }"
                />
                <div
                  *ngIf="
                    product.get('displayProductName')?.touched &&
                    product?.get('displayProductName')?.invalid
                  "
                  class="invalid-feedback"
                >
                  <div
                    *ngIf="
                      product?.get('displayProductName')?.errors?.['required']
                    "
                    i18n
                  >
                    This is required.
                  </div>
                </div>
              </div>
              <div class="flex-basis-30">
                <input
                  type="number"
                  class="form-control"
                  i18n-placeholder
                  placeholder="Amount *"
                  formControlName="amount"
                  [ngClass]="{
                    'is-invalid':
                      product.get('amount')?.touched &&
                      product.get('amount')?.errors,
                  }"
                />
                <div
                  *ngIf="
                    product.get('amount')?.touched &&
                    product?.get('amount')?.invalid
                  "
                  class="invalid-feedback"
                >
                  <div
                    *ngIf="product?.get('amount')?.errors?.['required']"
                    i18n
                  >
                    This is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
